export default "/images/vendor/@coreui/icons/svg/flag/cif-va.svg?b8899c6602111cf7098f35c56f28382c";